
export const wrapSubmitting = async (fn, state) => {
    try {
        state.onChange(true);
        await fn();
    } finally {
        state.onChange(false);
    }
};
